import { z } from 'zod'

// Mirrors backend/app/Http/Requests/Auth/*Request.php validation rules
// exactly, so client-side errors match what the server would say.
export const passwordSchema = z
  .string()
  .min(8, 'Password must be at least 8 characters')
  .regex(/[a-z]/, 'Password must contain a lowercase letter')
  .regex(/[A-Z]/, 'Password must contain an uppercase letter')
  .regex(/[0-9]/, 'Password must contain a number')

export const phoneSchema = z
  .string()
  .regex(/^[0-9]{7,15}$/, 'Enter a valid phone number (7-15 digits)')

export const otpCodeSchema = z.string().length(6, 'Enter the 6-digit code')
